import { client } from './sanity-client';
document.addEventListener('DOMContentLoaded', async () => {
    const banner = document.getElementById('cookie-consent-banner');
    const acceptBtn = document.getElementById('btn-accept-cookies');
    const rejectBtn = document.getElementById('btn-reject-cookies');

    if (!banner || !acceptBtn || !rejectBtn) return;

    let currentTermsVersion = null;
    try {
        const query = `*[_type == "privacyPolicyPage"][0]{lastUpdated, _updatedAt}`;
        const data = await client.fetch(query);
        if (data) {
            currentTermsVersion = data.lastUpdated || data._updatedAt;
        }
    } catch (error) {
        console.error('Error fetching privacy policy version:', error);
    }

    const consentStatus = localStorage.getItem('ga_cookie_consent');
    const storedTermsVersion = localStorage.getItem('ga_cookie_consent_version');

    const isVersionMismatch = currentTermsVersion && storedTermsVersion && new Date(storedTermsVersion) < new Date(currentTermsVersion);

    if (consentStatus === 'accepted' && !isVersionMismatch) {
        loadGoogleAnalytics();
    } else if (consentStatus === null || isVersionMismatch) {
        if (isVersionMismatch) {
            removeCookies();
        }
        // Show the banner with animation
        banner.classList.remove('d-none');
        // Force reflow
        void banner.offsetWidth;
        banner.classList.add('show');
    }

    acceptBtn.addEventListener('click', () => {
        localStorage.setItem('ga_cookie_consent', 'accepted');
        if (currentTermsVersion) {
            localStorage.setItem('ga_cookie_consent_version', currentTermsVersion);
        }
        banner.classList.remove('show');
        setTimeout(() => banner.classList.add('d-none'), 400); // match transition duration
        loadGoogleAnalytics();
    });

    rejectBtn.addEventListener('click', () => {
        localStorage.setItem('ga_cookie_consent', 'rejected');
        if (currentTermsVersion) {
            localStorage.setItem('ga_cookie_consent_version', currentTermsVersion);
        }
        banner.classList.remove('show');
        setTimeout(() => banner.classList.add('d-none'), 400);
    });

    function removeCookies() {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
            if (name.startsWith('_ga')) {
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname.replace(/^www\./, '');
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
            }
        }
    }

    function loadGoogleAnalytics() {
        // Prevent loading multiple times
        if (window.gtag) return;

        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-WCZZQHFZMB';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'G-WCZZQHFZMB');
        `;
        document.head.appendChild(script2);
    }
});
